import { useAppRouter } from '@shared/hooks';
import { Suspense } from 'react';
import { RouterProvider } from 'react-router-dom';

export function AppRoutes() {
  const { activeRouter } = useAppRouter();

  return (
    <Suspense>
      <RouterProvider router={activeRouter} />
    </Suspense>
  );
}
